import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { fetchData } from "../../../helpers/getData/fetchData";
import { PrincipalLayouts } from "../../../../layouts/PrincipalLayouts";
import { useLocation } from "react-router-dom";
import { EventRegisteredTable } from "./EventRegisteredTable";



export const ViewRegistered = () => {

    const { t } = useTranslation('global');
    const location = useLocation();
    const [reloadData, setReloadData ] = useState(false)
    const searchParams = new URLSearchParams(location.search);
    const [eventListData, setEventListData] = useState('isLoading')
    
    useEffect(() => {
        fetchData(setEventListData, `/eventRegister?eventId=${searchParams.get('event')}`, t)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t, reloadData])


    return (
        <PrincipalLayouts>
            {
                eventListData !== 'isLoading' && 
                <EventRegisteredTable rows={eventListData} event={searchParams.get('name')} setReloadData={setReloadData}/>
            }
        </PrincipalLayouts>
    )
}
